;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["default_currency", "id", "name", "datetime", "account_id", "current_user", "bank_details", "status", "start_date", "settlement_recon_type", "can_execute_settlement"],
  data: function data() {
    return {
      loading: false,
      error_message: null,
      creating: false,
      settlement_detail_records: [],
      sales_encoded: [],
      canExecuteSettlement: null,
      settlement_summary: {
        settled: 0,
        pending: 0
      },
      bank_data: {},
      downloadable_items: (0, _stringify2.default)({
        type: "single",
        account_id: this.account_id,
        date: this.start_date
      })
    };
  },
  mounted: function mounted() {
    this.bank_data = JSON.parse(this.bank_details);
    this.fetch_settlement_detail_collection_summary();
    this.fetch_settlement_detail_records();
    this.canExecuteSettlement = this.can_execute_settlement;
    console.log(this.can_execute_settlement);
  },

  computed: {
    can_execute_automatic_settlement: function can_execute_automatic_settlement() {
      if ((this.status == "pending" || this.status == "generated") && this.bank_data.bank_account_no) {
        return true;
      }
      return false;
    }
  },
  methods: {
    get_view: function get_view(id) {
      return "/settlements/" + id + "/details";
    },
    initiate_download: function initiate_download() {},
    fetch_settlement_detail_collection_summary: function fetch_settlement_detail_collection_summary() {
      var _this = this;

      var auth_url = "/api/settlements/" + this.id + "/details/summary";
      this.loading = true;
      Vue.axios.get(auth_url).then(function (response) {
        _this.loading = false;
        _this.settlement_summary.pending = _this.extract_amount(response.data.filter(function (v) {
          return v.status != "settled";
        }));
        _this.settlement_summary.settled = _this.extract_amount(response.data.filter(function (v) {
          return v.status == "settled";
        }));
      }).catch(function () {
        _this.loading = false;
      });
    },
    extract_amount: function extract_amount(elem) {
      if (elem.length == 1) {
        return elem[0].amount;
      }
      if (elem.length > 1) {
        return elem.reduce(this.getSum, 0);
      }
      return 0;
    },
    formatNumber: function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },

    to_human: function to_human(x) {
      if (x == null) return 0;
      var n = this.to_fixed(x);
      return this.formatNumber(n.toLocaleString());
    },
    to_fixed: function to_fixed(val) {
      return (Math.round(val * 100) / 100).toFixed(2);
    },
    fetch_settlement_detail_records: function fetch_settlement_detail_records() {
      var _this2 = this;

      var auth_url = "/api/settlements/" + this.id + "/details";
      this.loading = true;
      Vue.axios.get(auth_url).then(function (response) {
        _this2.loading = false;
        _this2.settlement_detail_records = response.data.records || [];
        var total = _this2.settlement_detail_records.reduce(_this2.getSum, 0);
        _this2.settlement_detail_records.map(function (v) {
          _this2.sales_encoded.push({
            name: v.gateway,
            y: Math.round(v.amount * 100 / total)
          });
        });
        _this2.render_pg_graphs();
      }).catch(function () {
        _this2.loading = false;
      });
    },
    getSum: function getSum(total, num) {
      return total + Math.round(num.amount);
    },

    render_pg_graphs: function render_pg_graphs() {
      var gatewaySales = this.sales_encoded;
      $("#paymentGateways").highcharts({
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
          height: 350,
          padding: 0,
          margin: 0,
          spacing: 0
        },
        title: {
          text: ""
        },
        legend: {
          enabled: false,
          align: "center",
          layout: "horizontal",
          verticalAlign: "top",
          alignColumns: false,
          margin: 30
        },
        tooltip: {
          headerFormat: "",
          pointFormat: "<span style=\"color:{point.color}\">\u25CF</span> {point.name}: <b>{point.y}</b>%<br/>"
        },
        credits: { enabled: false },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            showInLegend: true,
            dataLabels: {
              enabled: true
            }
          }
        },
        series: [{
          minPointSize: 10,
          innerSize: "20%",
          zMin: 0,
          name: "Payment Gateways",
          data: gatewaySales
        }]
      });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"header mt-md-5"},[_c('div',{staticClass:"header-body"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('h6',{staticClass:"header-pretitle"},[_vm._v("Summary")]),_vm._v(" "),_c('h1',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("\n              Total funds collected as at "+_vm._s(_vm.datetime)+"\n            ")]),_vm._v(" "),_c('div',[_c('h3',{staticStyle:{"color":"red"}},[_vm._v("Bank Settlement Details")]),_vm._v(" "),_c('p',[_vm._v("\n                Bank Account No: "+_vm._s(this.bank_data.bank_account_no)+" "),_c('br'),_vm._v("\n                Bank: "+_vm._s(this.bank_data.bank_name)+" "),_c('br'),_vm._v("\n                Bank Branch: "+_vm._s(this.bank_data.bank_account_branch)+" "),_c('br')])]),_vm._v(" "),_c('download-report',{attrs:{"item":_vm.downloadable_items,"name":"Download Settlement Items"}},[_vm._v("\n              Download Report\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.canExecuteSettlement == 'true')?_c('div',[(_vm.settlement_recon_type == 'automatic')?_c('div',{staticClass:"col-auto"},[(_vm.can_execute_automatic_settlement)?_c('button',{staticClass:"btn btn-outline-primary lift",attrs:{"data-toggle":"modal","data-target":"#runSettlementModal"}},[_vm._v("\n                Execute Settlement\n              ")]):_vm._e(),_vm._v(" "),(_vm.status == 'generated_settlement_inprogress')?_c('button',{staticClass:"btn btn-outline-warning"},[_vm._v("\n                Settlement in progress\n              ")]):_vm._e(),_vm._v(" "),(_vm.status == 'settled')?_c('button',{staticClass:"btn btn-danger"},[_vm._v("\n                Settled\n              ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.settlement_recon_type == 'manual')?_c('div',{staticClass:"col-auto"},[(_vm.status == 'generated' && _vm.can_execute_automatic_settlement)?_c('button',{staticClass:"btn btn-outline-primary lift",attrs:{"data-toggle":"modal","data-target":"#uploadPaymentSlipModal"}},[_vm._v("\n                Execute Settlement\n              ")]):_vm._e(),_vm._v(" "),(_vm.status == 'settled')?_c('button',{staticClass:"btn btn-danger"},[_vm._v("\n                Settled\n              ")]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._m(0)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-7"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6 col-xl"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body bg-success-soft rounded"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('h5',{staticClass:"text-uppercase text-success mb-2"},[_vm._v("\n                      Pending Settlement\n                    ")]),_vm._v(" "),_c('div',{staticClass:"h1 mb-0"},[_vm._v("\n                      "+_vm._s(_vm.default_currency)+".\n                      "+_vm._s(_vm.to_human(_vm.settlement_summary.pending))+"\n                    ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6 col-xl"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body bg-primary-soft rounded"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('h5',{staticClass:"text-uppercase text-primary mb-2"},[_vm._v("Settled")]),_vm._v(" "),_c('div',{staticClass:"h1 mb-0"},[_vm._v("\n                      "+_vm._s(_vm.default_currency)+".\n                      "+_vm._s(_vm.to_human(_vm.settlement_summary.settled))+"\n                    ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-nowrap card-table"},[_vm._m(2),_vm._v(" "),_vm._l((_vm.settlement_detail_records),function(item,index){return _c('tbody',{key:index,staticClass:"fs-base"},[_c('tr',[_c('td',[_vm._v(_vm._s(item.gateway))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.applications || 0))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.currency))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        "+_vm._s(_vm.to_human(item.amount))+"\n                      ")])])])})],2)])])])])]),_vm._v(" "),_vm._m(3)])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-auto"},[_c('a',{staticClass:"btn btn-primary lift",attrs:{"href":"/settlements"}},[_vm._v("Back")])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_vm._v("Payment Gateway Breakdown")])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Gateway")]),_vm._v(" "),_c('th',[_vm._v("Applications")]),_vm._v(" "),_c('th',[_vm._v("Currency")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Amount")])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-5"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_vm._v("Payment Gateway Summary")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticStyle:{"width":"100%","height":"350px","overflow-x":"hidden"},attrs:{"id":"paymentGateways"}})])])])])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1c3398e8", __vue__options__)
  } else {
    hotAPI.reload("data-v-1c3398e8", __vue__options__)
  }
})()}